{
  "welcome": {
    "title": "أهلًا بك، {{name}}",
    "title_noName": "أهلًا بك في Rhemn",
    "body": "كل ما يتوهّج سيُريك ما يفعله. استكشف بأي ترتيب، وفي أي وقت تشاء.",
    "start": "ابدأ الاستكشاف",
    "later": "ليس الآن"
  },
  "card": {
    "tryIt": "جرّبه",
    "takeALook": "ألقِ نظرة",
    "pro": "جزء من Rhemn Pro",
    "close_aria": "إغلاق"
  },
  "pill": {
    "progress": "استكشفت {{count}} من {{total}}",
    "progress_short": "{{count}} من {{total}}",
    "done": "تم",
    "done_aria": "إنهاء الاستكشاف",
    "complete": "اكتمل الاستكشاف"
  },
  "sr": {
    "started": "وضع الاستكشاف مفعّل. تعرض الأزرار ما تفعله قبل تنفيذه.",
    "hint": "وضع الاستكشاف. يعرض ما يفعله هذا أولًا.",
    "ended": "وضع الاستكشاف متوقف."
  },
  "settings": {
    "row": "كيف يعمل Rhemn",
    "row_sub": "نظرة موجزة على كل جزء",
    "row_aria": "كيف يعمل Rhemn: استكشف التطبيق مجددًا",
    "helpCaption": "المساعدة"
  },
  "steps": {
    "intention": {
      "title": "نيّة اليوم",
      "body": "اكتب أهم أمر لديك اليوم، وضع علامة عليه حين تُنجزه."
    },
    "now": {
      "title": "يومك بحسب الصلاة",
      "body": "يقسّم Rhemn يومك عند كل صلاة. يُظهر هذا الوقت المتبقي حتى الصلاة التالية، وما خطّطت له خلاله."
    },
    "verse": {
      "title": "رؤى الآيات",
      "body": "اطرح سؤالًا عن آية اليوم، واقرأ تفسيرًا موجزًا، واعثر على آيات في الموضوع نفسه."
    },
    "qibla": {
      "title": "القبلة",
      "body_chrome": "اتجاه الكعبة من موقعك، بالدرجات من الشمال.",
      "body_ios": "يشير إلى الكعبة من موقعك. فعّل البوصلة الحية لتتبعك وأنت تستدير."
    },
    "prayer": {
      "title": "مواقيت الصلاة",
      "body_chrome": "مواقيت الصلوات الخمس اليوم في موقعك. اختر طريقة الحساب التي يتّبعها مسجدك.",
      "body_ios": "صلاتك التالية في لمحة. افتحها لترى المواقيت الخمسة وتذكيرًا لكل صلاة."
    },
    "tasks": {
      "title": "المهام",
      "body": "رتّب مهامك في قوائم، وامنح كل مهمة مكانًا بين الصلوات."
    },
    "notes": {
      "title": "الملاحظات",
      "body_chrome": "اكتب، أو تحدّث فحسب. يُفرّغ Rhemn ملاحظاتك الصوتية واجتماعاتك نصًّا، ثم يلخّصها.",
      "body_ios": "اكتب، أو تحدّث فحسب. يحوّل Rhemn ما تقوله إلى ملاحظات واضحة وملخّصة."
    },
    "profile": {
      "title_chrome": "ملفك الشخصي",
      "body_chrome": "إعدادات حسابك وخصوصيتك. عُد إلى هنا لاستكشاف Rhemn مجددًا.",
      "title_ios": "المزيد",
      "body_ios": "الآيات المحفوظة والقبلة وإعدادات حسابك. يمكنك استكشاف Rhemn مجددًا من هنا."
    }
  }
}
